import { render, staticRenderFns } from "./private.vue?vue&type=template&id=dc190d1c&"
import script from "./private.vue?vue&type=script&lang=js&"
export * from "./private.vue?vue&type=script&lang=js&"
import style0 from "./private.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports